import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

import InsetContainer from 'components/common/containers/inset_container';
import InformationI from 'components/common/icons/information_i.jsx';
import Tooltip from 'components/common/tooltip';

export default function ResultsHeader({
  inset = 'large',
  isLookupPending,
  resultsCount,
  shouldShowSuggestions,
  suggestionsCount,
}) {
  let header;

  if (isLookupPending) {
    header = (
      <InsetContainer inset={inset}>
        <p>Searching for matches...</p>
      </InsetContainer>
    );
  } else if (shouldShowSuggestions) {
    header = (
      <InsetContainer inset={inset}>
        <div>
          <Trans
            components={{
              highlight: <span className="externalCustomerLookupSearchResults-header-text-highlight" />,
            }}
            i18nKey="We found <highlight>{{suggestionsCount}} possible matches.</highlight> Try searching for other matches"
            values={{ suggestionsCount }}
          />
          <div className="externalCustomerLookupSearchResults-header-tooltipIcon-container">
            <Tooltip enabled message="Results are based on the customer’s profile information." position="bottom">
              <InformationI className="externalCustomerLookupSearchResults-header-tooltipIcon" />
            </Tooltip>
          </div>
        </div>
      </InsetContainer>
    );
  } else {
    const matchesText = resultsCount !== 1 ? 'matches' : 'match';
    const suggestedAction = resultsCount < 1 ? 'changing' : 'refining';
    const suggestionText = resultsCount !== 1 ? `Try ${suggestedAction} your search for better results` : '';

    header = (
      <InsetContainer inset={inset}>
        <p>
          <Trans
            components={{
              highlight: <span className="externalCustomerLookupSearchResults-header-text-highlight" />,
            }}
            i18nKey="We found <highlight>{{resultsCount}} possible {{matchesText}}.</highlight> {{suggestionText}}"
            values={{ matchesText, resultsCount, suggestionText }}
          />
        </p>
      </InsetContainer>
    );
  }

  return <div className="externalCustomerLookupSearchResults-header">{header}</div>;
}

ResultsHeader.propTypes = {
  inset: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
  isLookupPending: PropTypes.bool,
  resultsCount: PropTypes.number.isRequired,
  shouldShowSuggestions: PropTypes.bool,
  suggestionsCount: PropTypes.number.isRequired,
};
